import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable} from 'rxjs';
import { environment } from 'src/app/core/environments/environment';
import { Success } from 'src/app/core/interceptors/models/interceptors.model';
import { AuthService } from 'src/app/core/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class DatabaseService {
  connectDatabase = { name: '', server: '' };
  isConnected$ = new BehaviorSubject<boolean | null>(null);

  constructor(
    private readonly http: HttpClient,
    private readonly authService: AuthService
  ) {}

  public getBaseUrl(url: string): string {
    return environment.api.url + url;
  }

  public getServerInstance(typeId: number): Observable<any[]> {
    return this.http.get<any[]>(this.getBaseUrl(`/DatabaseManagement/GetServerInstance/${typeId}`));
  }

  public getDatabaseByServerInstance(payload: any): Observable<any> {
    return this.http.post<any>(
      this.getBaseUrl('/DatabaseManagement/GetDatabaseByServerInstance'),
      payload,
    );
  }

  public getConnectedDatabase(): Observable<any> {
    return this.http.get<any>(this.getBaseUrl('/DatabaseManagement/GetConnectedDatabase'));
  }

  public verifyDatabaseVersion(): Observable<any[]> {
    return this.http.get<any[]>(
      this.getBaseUrl('/DatabaseManagement/VerifyDatabaseVersion'),
    );
  }

  public executeScriptPost(connectionId: string) {
    return this.http.post(
      '/DatabaseManagement/ExecuteScript',
      { connectionId }
    );
  }
  
  public selectDatabase(payload: any): Observable<Success> {
    return this.http.post<Success>(
      this.getBaseUrl('/DatabaseManagement/SelectDatabase'),
      payload,
    );
  }
  
  public restoreDatabase(payload: any): Observable<Success> {
    return this.http.post<Success>(
      this.getBaseUrl('/DatabaseManagement/RestoreDatabase'),
      payload,
    );
  }

  public resetConnection(): Observable<Success> {
    return this.http.get<Success>(
      this.getBaseUrl('/DatabaseManagement/ResetConnection'));
  }

backupDatabase(dbType: number) {
  const token = this.authService.getToken();

  return this.http.get(`/DatabaseManagement/BackupDatabase/${dbType}`, {
    responseType: 'blob',
    observe: 'response',
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
}

  public restoreCurrentDatabase(payload: any): Observable<Success> {
    return this.http.post<Success>(
      this.getBaseUrl('/DatabaseManagement/RestoreCurrentDatabase'),
      payload,
    );
  }

  public getSystemVersions(): Observable<any> {
    return this.http.get<any>(
      this.getBaseUrl('/Common/GetSystemVersions'),
    );
  }
}
